<div *ngIf="editMode" class="add">
  <div class="toggle prime" [class.active]="ddVisible" (click)="add()">
    <div class="two-lines"></div>
    <ico ico="add_circle_24"></ico>
    <div class="two-lines"></div>
  </div>
</div>
<h1>{{page.name}}</h1>
<div class="search">
      <label for="search">Поиск</label>
      <input id="search" type="text" [(ngModel)]="searchString" (keyup)="search()" />
</div>
<div class="tags" *ngIf="tags && tags.length">
  <div class="tag" *ngFor="let tag of tags" (click)="selectTag(tag)" [class.active]="tag===currentTag">{{tag}}</div>
</div>

<pagination [listId]="listId"></pagination>
<div class="items">
  <publications-list-item *ngFor="let publication of publications" [publication]="publication" [editMode]="editMode"></publications-list-item>
</div>
<pagination [listId]="listId"></pagination>
